import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EventEmitter, Injectable, Output } from "@angular/core";
import { environment } from "src/environments/environment";
import * as CryptoJS from 'crypto-js';
import { SharedService } from "../services1/shared.service";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class InventoryService {
    url: any = environment.API_URL;
    lang = sessionStorage.getItem('lang');

    constructor(
        private http: HttpClient,
        private sharedService: SharedService,
    ) { }

    getBuynowInventorysList(data: any) {
        return this.http.post(this.url + 'buynow/get-buynow-vehicles', this.sharedService?.newEncryptJson(data));
    }

    getBuyNowDetailsInformation(id: any, data) {
        return this.http.post(this.url + `buynow/get-buynow-vehicles-details-byid/${id}`, data);
    } 

     getBuyNowDetails(id: any, data) {
        return this.http.post(this.url + `buynow/get-buynow-vehicles-byid/${id}`, data);
    } 

    buynowCreateReceiptOtp(data) {
        return this.http.post(this.url + `buynow/create-otp`, data);
    }

    createBuynowReceipt(data) {
        return this.http.post(this.url + `buynow/create-buynow-receipt`, data);
    }

    downloadSaleInvoice(data) {
        return this.http.post(this.url + `upload/download-sale-invoice`, data, {
            responseType: 'blob'
        });
    } 
}
